import $ from "jquery";

class Em {
	constructor() {
		this.dom();
		this.customEvents();
	}

	dom() {
		// Global
		this.$document = $(document);
		this.$window = $(window);
		this.$body = $('body');

		//Header
		this.$header = $('#header');
	}

	customEvents() {
		// Throttled resize
		this.$window.off('resize.EmCustomEvents'); // off is required or it will add resize event every time when Em class is extended
		this.$window.on('resize.EmCustomEvents', (event) => {
			if (window.resizing) clearTimeout(window.resizing);

			window.resizing = setTimeout(() => {
				this.$window.trigger('resized');
			}, 300);
		});
	}
}

export default Em;
